import { Controller } from '@hotwired/stimulus'
import { PreviewClient } from 'api/preview_client'
import { FileAttacher, disablingSubmitButtonOnUpload } from 'api/file_attacher'
import { Confirmable, ConfirmableEvent } from 'mixins/confirmable'
import dragDrop from 'drag-drop'
import { Toast } from 'bootstrap'
import { showPublicDailyReportNotice } from 'common/modal'
import { MarkdownEditable } from 'mixins/markdown_editable'
class DailyReports extends MarkdownEditable(Confirmable(Controller)) {
  connect () {
    this.initConfirmableForms([this.formTarget.id])
    this.client = new PreviewClient({ previewTarget: this.previewTarget, bodyTarget: this.bodyTarget })
    this.fileAttacher = new FileAttacher({
      bodyTarget: this.bodyTarget,
      callback: disablingSubmitButtonOnUpload(this.submitTarget)
    })
    dragDrop(this.bodyTarget, (files) => {
      this.fileAttacher.uploadFiles(files, window)
    })
    this.connectMarkdownEditable(this.bodyTarget, this.previewTarget)
  }

  disconnect () {
    this.disconnectMarkdownEditable()
    super.disconnect()
  }

  scroll () {
    this.scrollMarkdownPreview()
  }

  updatePreview () {
    this.client.call()
  }

  clickFileUploadButton (e) {
    e.preventDefault()
    this.filesTarget.click()
  }

  changeFiles () {
    const files = this.filesTarget.files
    if (files === null) {
      throw new Error('No files found')
    }
    this.fileAttacher.uploadFiles(Array.from(files), window)
  }

  pasteClipboardData (e) {
    if (e.clipboardData.types.indexOf('Files') > -1) {
      this.fileAttacher.uploadFiles(Array.from(e.clipboardData.files), window)
      e.preventDefault()
    }
  }

  open (e) {
    if (!this.confirmedValue) {
      e.preventDefault()
      this.showOpenConfirmation(e.currentTarget)
    }
  }

  save (e) {
    if (e.code === 'KeyS' && (e.ctrlKey || e.metaKey)) {
      e.preventDefault()
      this.submit()
    }
  }

  requireOpenConfirmation () {
    return this.openConfirmedTarget.value !== 'true'
  }

  showOpenConfirmation (submitter) {
    if (!this.formTarget.checkValidity()) {
      this.formTarget.reportValidity()
      return
    }
    const OnClickHandler = () => {
      this.formTarget.dispatchEvent(new Event(ConfirmableEvent.reset))
      this.formTarget.requestSubmit(submitter)
    }
    const OnHideHandler = () => { }
    // HACK: Confirmableのデータ同期をしないとsystem specで Blocked confirmが出る
    this.formTarget.dispatchEvent(new Event(ConfirmableEvent.reset))
    showPublicDailyReportNotice(OnClickHandler, OnHideHandler)
  }

  submit () {
    if (!this.formTarget.reportValidity()) return
    this.formTarget.requestSubmit(this.autosaveTarget)
  }

  showAutosaveToast (event) {
    const { success, formSubmission } = event.detail
    if (!success || formSubmission.submitter !== this.autosaveTarget) return
    const delay = process.env.NODE_ENV === 'test' ? 10000 : 5000
    const toast = new Toast(this.alertTarget, { delay })
    toast.show()
  }
}
DailyReports.targets = ['preview', 'title', 'body', 'files', 'submit', 'form', 'publishedAt', 'alert', 'openConfirmed', 'autosave']
DailyReports.values = { id: Number, confirmed: Boolean }
export default DailyReports
